export default __webpack_public_path__ + "static/media/hunting-exprience.938388dd.jpg";